

import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment-timezone';
import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form8";
const form8State = namespace("Form8");

import { form8DataInfoType } from '@/types/Information/Form8';
import { chambersHearingJsonInfoType, partiesDataJsonDataType } from '@/types/Information/json';
import {justiceNames} from '@/components/utils/JusticeName';

@Component
export default class Form8StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;

    @form8State.State
    public currentOrder: chambersHearingJsonInfoType;  

    @informationState.State
    public fileNumber: string;

    @form8State.State
    public form8Info: form8DataInfoType;

    @form8State.Action
    public UpdateForm8Info!: (newForm8Info: form8DataInfoType) => void  
    
    @form8State.State
    public currentNoticeOfApplicationToVaryId: string;

    @form8State.Action
    public UpdateCurrentNoticeOfApplicationToVaryId!: (newCurrentNoticeOfApplicationToVaryId: string) => void
    
    dataReady = false;    
    partyNames: string[] = [];  
    updateOrderDetails = 0;
    orderDateValue = '';

    state = {        
        filingParties:null,         
        authorizedName:null,
        orderDate: null,
        judgeName: null,
        judgeNameOther: null
    }  

    justiceNameOptions = [];
    
    created(){
        this.justiceNameOptions = justiceNames
    }

    mounted() {
        this.dataReady = false;
        this.extractInfo();              
    }

    public updateOrderDate(){       
        this.form8Info.orderDate = this.orderDateValue;        
        this.updateOrderDetails ++;
        this.recheckStates()
    }

    public extractInfo(){       

        if(this.currentNoticeOfApplicationToVaryId){
            this.getForm8Data();
           
        } else {   
            
            const form8Data = {} as form8DataInfoType;

            form8Data.appellants = this.partiesJson.appellants
            form8Data.respondents = this.partiesJson.respondents;
            form8Data.formSevenNumber = this.fileNumber;
            
            form8Data.version = this.$store.state.Application.version;  
            
            const judgeName = this.currentOrder && this.currentOrder.JudgeLastName? (
                (this.currentOrder.JudgeSalutation? this.currentOrder.JudgeSalutation+' ':'Justice ')
                +this.currentOrder.JudgeLastName
            ).trim() : ''

            if(judgeName){
                const justiceIndex = justiceNames.findIndex(name=> name.toLowerCase().includes(judgeName.toLowerCase()))
                if(justiceIndex>-1){
                    form8Data.judgeName = justiceNames[justiceIndex]
                    form8Data.judgeNameOther=''
                }
                else{
                    form8Data.judgeName='Other'
                    form8Data.judgeNameOther=judgeName
                }
            } else {
                form8Data.judgeName='';
                form8Data.judgeNameOther='';
            }

            const orderDate = this.currentOrder?.JudgmentDate?this.currentOrder.JudgmentDate.slice(0,10):'';
            form8Data.orderDate = orderDate;
            this.orderDateValue = orderDate; 

            let applicantNames = [];
            let respondentNames = [];
            
            for (const respondent of form8Data.respondents){
                respondentNames.push(respondent.name);
            }

            for (const applicant of form8Data.appellants){ 
                applicantNames.push(applicant.name);
            }

            form8Data.respondentNames = respondentNames.join(', ');
            form8Data.appellantNames = applicantNames.join(', ');
  
            this.UpdateForm8Info(form8Data);                       
            this.saveForm(true);
        }
    }

    get isPastDeadline(){

        const today = new Date();
        const orderDate = new Date(this.form8Info.orderDate);

        const TimePast = today.getTime() - orderDate.getTime();
        const daysPast = TimePast / (1000 * 3600 * 24);        
        
        return daysPast > 30;
    }

    public extractPartiesData(){
        
        this.partyNames = [];

        for (const respondent of this.form8Info.respondents){          
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form8Info.appellants){           
            this.partyNames.push(applicant.name);  
        }       
        this.dataReady = true;
    }

    public getForm8Data() {        
       
        this.$http.get('/form8/forms/'+this.currentNoticeOfApplicationToVaryId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form8Data = response.data.data    
                this.orderDateValue = form8Data.orderDate? form8Data.orderDate.slice(0,10): '';
                this.UpdateForm8Info(form8Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {            
            filingParties:null,
            orderDate: null,
            judgeName: null,  
            judgeNameOther: null,               
            authorizedName:null
        }
        this.dataReady = true; 
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date <= day);           
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){

        this.state.filingParties = this.form8Info.filingParties?.length>0? null :false; 
        this.state.orderDate = this.form8Info.orderDate? null:false;
        
        this.state.judgeName = this.form8Info.judgeName? null :false;
        this.state.judgeNameOther = this.form8Info.judgeName=='Other' && !this.form8Info.judgeNameOther? false: null;
        
        this.state.authorizedName = !this.form8Info.authorizedName? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }            
        }
        return true            
    }    

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form8/forms';

        if (this.currentNoticeOfApplicationToVaryId){
            method = 'put';
            url = '/form8/forms/'+this.currentNoticeOfApplicationToVaryId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form8Info,
                    type:'Form8',
                    description:'Notice of Application to Vary or Change an Order of a Justice'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form8Info,
                    type:'Form8',
                    description:'Notice of Application to Vary or Change an Order of a Justice'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentNoticeOfApplicationToVaryId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form8"}) 
    }

}
